module.exports = __webpack_public_path__ + "static/media/Error_icon.7883bfc1.svg";